export interface GetMessage {
  code: number;
  status: string;
  response: {
    message: HomeMessage;
  };
}

export interface HomeMessage {
  id: number | null;
  header: string;
  body: string;
  displayType: MESSAGE_TYPE;
  start: Date | null;
  end: Date | null;
}

export interface GetAllMessages {
  code: number;
  status: string;
  response: {
    messages: HomeMessage[];
  };
}

export enum MESSAGE_TYPE {
  INFO,
  NOTICE,
  ALERT,
}
